@if (isOpen) {
<div class="modal-overlay" (click)="onOverlayClick($event)">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="onClose()" aria-label="Close settings">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>

    <aside class="settings-sidebar">
      <div class="nav-group">
        <span class="nav-group-label">Account</span>
        <button class="nav-row" [class.active]="activeSection === 'account'" (click)="selectSection('account')">
          <span class="nav-avatar" [class.has-icon]="userAvatar">
            @if (userAvatar) {
            <img [src]="userAvatar" alt="" />
            } @else {
            <span class="nav-avatar-initials">{{ userInitials }}</span>
            }
          </span>
          <span class="nav-row-label">{{ userName }}</span>
        </button>
        <button class="nav-row disabled" disabled>
          <lucide-icon name="sliders-horizontal" [size]="15" class="nav-ic" />
          <span class="nav-row-label">Preferences</span>
        </button>
        <button class="nav-row" [class.active]="activeSection === 'notifications'"
          (click)="selectSection('notifications')">
          <lucide-icon name="bell" [size]="15" class="nav-ic" />
          <span class="nav-row-label">Notifications</span>
        </button>
      </div>

      <div class="nav-group">
        <span class="nav-group-label">Workspace</span>
        <button class="nav-row" [class.active]="activeSection === 'workspace-general'"
          (click)="selectSection('workspace-general')">
          <lucide-icon name="settings" [size]="15" class="nav-ic" />
          <span class="nav-row-label">General</span>
        </button>
        <button class="nav-row disabled" disabled>
          <lucide-icon name="lock" [size]="15" class="nav-ic" />
          <span class="nav-row-label">Security</span>
        </button>
      </div>

      @if (projects.length > 0) {
      <div class="nav-group">
        <span class="nav-group-label">Projects</span>
        <button class="nav-row" [class.active]="activeSection === 'projects-general'"
          (click)="selectSection('projects-general')">
          <lucide-icon name="lock" [size]="15" class="nav-ic" />
          <span class="nav-row-label">General</span>
        </button>
      </div>
      }

      <div class="nav-group">
        <span class="nav-group-label">Features</span>
        <button class="nav-row disabled" disabled>
          <lucide-icon name="gem" [size]="15" class="nav-ic" />
          <span class="nav-row-label">Connections</span>
        </button>
        <button class="nav-row disabled" disabled>
          <lucide-icon name="package" [size]="15" class="nav-ic" />
          <span class="nav-row-label">Declunk MCP</span>
        </button>
      </div>

      <div class="nav-group">
        <span class="nav-group-label">Billing</span>
        <button class="nav-row disabled" disabled>
          <lucide-icon name="credit-card" [size]="15" class="nav-ic" />
          <span class="nav-row-label">Billing</span>
        </button>
        <button class="nav-row disabled" disabled>
          <lucide-icon name="circle-check" [size]="15" class="nav-ic" />
          <span class="nav-row-label">Plans</span>
        </button>
      </div>

      @if (!isProd) {
        <div class="nav-group">
          <span class="nav-group-label">Design System</span>
          <button routerLink="/showcase" class="nav-row disabled">
            <lucide-icon name="swatch-book" [size]="15" class="nav-ic" />
            <span class="nav-row-label">Showcase</span>
          </button>
        </div>
      }
    </aside>

    <div class="settings-content" #settingsContent>
      @if (activeSection === 'account') {
      <h1 class="page-title">Account</h1>

      <section class="settings-section">
        <h3 class="section-label">Profile</h3>
        <hr class="section-divider" />

        <div class="profile-row">
          <div class="profile-avatar-wrap">
            <span class="profile-avatar" [class.uploading]="isUploadingAvatar" [class.has-icon]="userAvatar">
              @if (userAvatar) {
              <img [src]="userAvatar" alt="" />
              } @else {
              <span class="profile-avatar-initials">{{ userInitials }}</span>
              }
            </span>
            <button type="button" class="avatar-upload-btn" (click)="avatarInput.click()" [disabled]="isUploadingAvatar"
              aria-label="Change profile picture">
              <lucide-icon name="camera" [size]="11" />
            </button>
            <input #avatarInput type="file" accept="image/*" class="avatar-file-input"
              (change)="onAvatarSelected($event)" />
          </div>

          <div class="form-field">
            <label for="settingsFirstName">First Name</label>
            <input id="settingsFirstName" type="text" [(ngModel)]="firstName" (blur)="saveName('first_name')" />
          </div>

          <div class="form-field">
            <label for="settingsLastName">Last Name</label>
            <input id="settingsLastName" type="text" [(ngModel)]="lastName" (blur)="saveName('last_name')" />
          </div>
        </div>
      </section>

      <section class="settings-section">
        <h3 class="section-label">Security</h3>
        <hr class="section-divider" />

        <div class="info-row">
          <label>Email</label>
          <p class="info-value">{{ userEmail }}</p>
        </div>

        <div class="info-row info-row--with-action">
          <div>
            <label>Password</label>
            <p class="info-hint">Change password for your account</p>
          </div>
          <button class="btn-outline" (click)="togglePasswordForm()">Change Password</button>
        </div>

        @if (passwordFormOpen) {
        <div class="password-form">
          <div class="form-field">
            <label for="currentPassword">Current password</label>
            <input id="currentPassword" type="password" [(ngModel)]="currentPassword" />
          </div>
          <div class="form-field">
            <label for="newPassword">New password</label>
            <input id="newPassword" type="password" [(ngModel)]="newPassword" />
          </div>
          <div class="form-field">
            <label for="confirmPassword">Confirm new password</label>
            <input id="confirmPassword" type="password" [(ngModel)]="confirmPassword" />
          </div>
          <div class="password-form-actions">
            <button class="btn-text" (click)="togglePasswordForm()">Cancel</button>
            <button class="btn-primary" [disabled]="passwordSubmitting" (click)="submitPasswordChange()">Save</button>
          </div>
        </div>
        }
      </section>

      <section class="settings-section">
        <h3 class="section-label">Support</h3>
        <hr class="section-divider" />

        <div class="danger-box">
          <div class="danger-row">
            <div>
              <p class="danger-title">Delete my Account</p>
              <p class="danger-desc">Permanently delete your account. You'll no longer be able to access your
                projects or any of the projects you belong to.</p>
            </div>
            <button class="btn-danger-outline">Delete my Account</button>
          </div>

          <div class="danger-row">
            <div>
              <p class="danger-title">Log Out of All Devices</p>
              <p class="danger-desc">Log out of active sessions on all your devices, other than this one</p>
            </div>
            <button class="btn-danger">Log Out of All</button>
          </div>
        </div>
      </section>
      }

      @if (activeSection === 'notifications') {
      @if (notifPrefsLoading) {
      <div class="notif-settings-status">Loading settings…</div>
      } @else if (notifPrefsError) {
      <div class="notif-settings-status">Couldn't load settings. Try again.</div>
      } @else {
      @for (group of groupedSettingsPrefs; track group.label; let gi = $index) {
      <section class="settings-section">
        <div class="notif-section-head">
          <h3 class="section-label">{{ group.label }}</h3>
          @if (gi === 0) {
          <div class="notif-pref-header">
            <span class="notif-pref-header-col">In-app</span>
            <span class="notif-pref-header-col">Email</span>
          </div>
          }
        </div>
        <hr class="section-divider" />

        @for (pref of group.prefs; track pref.type) {
        <div class="notif-pref-row">
          <div class="notif-pref-text">
            <p class="notif-pref-title">{{ pref.label }}</p>
            <p class="notif-pref-desc">{{ pref.description }}</p>
          </div>
          <button class="notif-toggle" type="button" [class.notif-toggle--on]="pref.enabled" (click)="togglePref(pref)"
            [attr.aria-label]="(pref.enabled ? 'Disable ' : 'Enable ') + pref.label + ' in-app'">
            <span class="notif-toggle-thumb"></span>
          </button>
          <button class="notif-check" type="button" [class.notif-check--on]="pref.emailEnabled"
            (click)="toggleEmail(pref)"
            [attr.aria-label]="(pref.emailEnabled ? 'Disable ' : 'Enable ') + pref.label + ' email'">
            @if (pref.emailEnabled) {
            <lucide-icon name="check" [size]="12" />
            }
          </button>
        </div>
        }
      </section>
      }
      }
      }

      @if (activeSection === 'workspace-general') {
      <h1 class="page-title">Workspace settings</h1>

      <section class="settings-section">
        <h3 class="section-label">Icon</h3>
        <hr class="section-divider" />

        <div class="profile-row">
          <div class="workspace-icon-wrap">
            <span class="workspace-icon" [class.uploading]="isUploadingIcon" [class.has-icon]="workspaceIcon">
              @if (workspaceIcon) {
              <img [src]="workspaceIcon" alt="" />
              } @else {
              <span class="workspace-icon-initials">{{ workspaceInitials }}</span>
              }
            </span>
            <button type="button" class="avatar-upload-btn" (click)="workspaceIconInput.click()"
              [disabled]="isUploadingIcon" aria-label="Change workspace icon">
              <lucide-icon name="camera" [size]="11" />
            </button>
            <input #workspaceIconInput type="file" accept="image/*" class="avatar-file-input"
              (change)="onWorkspaceIconSelected($event)" />
          </div>

          <div class="form-field">
            <label for="workspaceName">Workspace name</label>
            <input id="workspaceName" type="text" [(ngModel)]="workspaceName" (blur)="saveWorkspaceName()" />
          </div>
        </div>
      </section>

      <section class="settings-section">
        <h3 class="section-label">Team &amp; Roles</h3>
        <hr class="section-divider" />

        <div class="info-row info-row--with-action">
          <div>
            <label>Add members via link</label>
            <p class="info-hint">Only people with permission to invite members to this workspace can view this link.</p>
          </div>
          <div class="team-row-actions">
            <button class="btn-outline" [disabled]="!linkJoinEnabled || !workspaceInvitationCode"
              (click)="copyWorkspaceInviteLink()">Copy link</button>
            <button class="notif-toggle" type="button" [class.notif-toggle--on]="linkJoinEnabled"
              [disabled]="domainJoinLoading || isUpdatingLinkJoin" (click)="toggleLinkJoin()"
              [attr.aria-label]="(linkJoinEnabled ? 'Disable ' : 'Enable ') + 'adding members via link'">
              <span class="notif-toggle-thumb"></span>
            </button>
          </div>
        </div>

        <div class="info-row info-row--with-action">
          <div>
            <label>Join workspace</label>
            <p class="info-hint">Let anyone with an <strong>&#64;company</strong> email join this workspace.</p>
          </div>
          <button class="notif-toggle" type="button" [class.notif-toggle--on]="allowDomainJoin"
            [disabled]="domainJoinLoading || isUpdatingDomainJoin" (click)="toggleDomainJoin()"
            [attr.aria-label]="(allowDomainJoin ? 'Disable ' : 'Enable ') + 'joining via company email'">
            <span class="notif-toggle-thumb"></span>
          </button>
        </div>

        <div class="members-title">Members</div>

        @if (membersLoading) {
        <div class="notif-settings-status">Loading members…</div>
        } @else if (membersError) {
        <div class="notif-settings-status">Couldn't load members. Try again.</div>
        } @else {
        <div class="members-table">
          <div class="members-table-header">
            <span>Name</span>
            <span>Role</span>
            <span>Projects involved</span>
            <span>Last Active</span>
            <span></span>
          </div>

          @for (member of pagedMembers; track member.id) {
          <div class="members-table-row">
            <div class="member-cell">
              <span class="member-avatar">
                <span class="member-avatar-initials">{{ member.name.slice(0, 2).toUpperCase() }}</span>
              </span>
              <div class="member-text">
                <p class="member-name">{{ member.name }}</p>
                <p class="member-email">{{ member.email }}</p>
              </div>
            </div>
            @if (canEditOrgMemberRoles && member.role !== 'owner' && hasResolvedOrgRoleId(member.id)) {
            <select class="member-role-select" [ngModel]="orgMemberRoleOptionId(member)"
              [disabled]="isSavingOrgMemberRole(member.id) || orgRolesLoading"
              (ngModelChange)="onOrgMemberRoleChange(member, $event)">
              @for (option of orgRoleOptions; track option.id) {
              <option [value]="option.id">{{ option.label }}</option>
              }
            </select>
            } @else {
            <span class="member-placeholder-cell">{{ member.role ?? '—' }}</span>
            }
            <span class="member-placeholder-cell">{{ member.projects_involved }}</span>
            <span class="member-placeholder-cell">{{ member.last_active ? (member.last_active | date) : '—' }}</span>
            <button type="button" class="member-action-btn" disabled aria-label="Member actions">
              <lucide-icon name="ellipsis-vertical" [size]="14" />
            </button>
          </div>
          }
        </div>

        <div class="members-pagination">
          <span class="members-pagination-label">{{ memberPageRangeLabel }}</span>
          <div class="members-pagination-right">
            <select class="members-page-size" [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
              @for (size of pageSizeOptions; track size) {
              <option [value]="size">{{ size }} per page</option>
              }
            </select>
            <div class="members-pagination-controls">
              <button type="button" class="page-nav-btn" [disabled]="currentPage === 1"
                (click)="setPage(currentPage - 1)" aria-label="Previous page">
                <lucide-icon name="chevron-left" [size]="14" />
              </button>
              @for (page of memberPageNumbers; track page) {
              <button type="button" class="page-pill" [class.active]="page === currentPage" (click)="setPage(page)">{{
                page }}</button>
              }
              <button type="button" class="page-nav-btn" [disabled]="currentPage === totalMemberPages"
                (click)="setPage(currentPage + 1)" aria-label="Next page">
                <lucide-icon name="chevron-right" [size]="14" />
              </button>
            </div>
          </div>
        </div>
        }
      </section>

      <section class="settings-section">
        <div class="danger-box">
          <p class="section-label">Danger zone</p>

          <div class="danger-row">
            <div>
              <p class="danger-title">Leave workspace</p>
              <p class="danger-desc">Remove your account from this workspace. You'll lose access to the workspace
                and all of its content, including your projects.</p>
            </div>
            <button class="btn-danger-outline">Leave workspace</button>
          </div>

          <div class="danger-row">
            <div>
              <p class="danger-title">Delete workspace</p>
              <p class="danger-desc">Permanently delete this workspace, including all projects</p>
            </div>
            <button class="btn-danger">Delete workspace</button>
          </div>
        </div>
      </section>
      }

      @if (activeSection === 'projects-general' && projects.length > 0) {
      <div class="project-switcher-row">
        @for (project of projects; track project.id) {
        <button type="button" class="project-switcher-icon" [class.active]="project.id === selectedProjectId"
          [style.background]="project.logo ? 'transparent' : project.color" (click)="selectProject(project)"
          [attr.aria-label]="project.name" [attr.data-tip]="project.name">
          @if (project.logo) {
          <img [src]="project.logo" alt="" />
          } @else {
          <span class="project-switcher-initials">{{ project.name.slice(0, 2).toUpperCase() }}</span>
          }
        </button>
        }
      </div>

      <h1 class="page-title">{{ selectedProjectName }} Settings</h1>

      <section class="settings-section">
        <h3 class="section-label">Icon</h3>
        <hr class="section-divider" />

        <div class="profile-row">
          <div class="workspace-icon-wrap">
            <span class="workspace-icon" [class.uploading]="isUploadingProjectIcon" [class.has-icon]="projectIcon">
              @if (projectIcon) {
              <img [src]="projectIcon" alt="" />
              } @else {
              <span class="workspace-icon-initials">{{ projectInitials }}</span>
              }
            </span>
            <button type="button" class="avatar-upload-btn" (click)="projectIconInput.click()"
              [disabled]="isUploadingProjectIcon" aria-label="Change project icon">
              <lucide-icon name="camera" [size]="11" />
            </button>
            <input #projectIconInput type="file" accept="image/*" class="avatar-file-input"
              (change)="onProjectIconSelected($event)" />
          </div>

          <div class="form-field">
            <label for="projectName">Project name</label>
            <input id="projectName" type="text" [(ngModel)]="projectName" (blur)="saveProjectName()" />
          </div>
        </div>
      </section>

      <section class="settings-section">
        <h3 class="section-label">Project Team &amp; Roles</h3>
        <hr class="section-divider" />

        <div class="info-row info-row--with-action">
          <div>
            <label>Invite members to {{ selectedProjectName }} project</label>
            <p class="info-hint">Share a link to invite people to <strong>{{ selectedProjectName }}
                project</strong> outside the company workspace.</p>
          </div>
          <div class="team-row-actions">
            <button class="btn-outline" [disabled]="!projectLinkJoinEnabled || !projectInvitationCode"
              (click)="copyProjectInviteLink()">Copy link</button>
            <button class="btn-outline" [disabled]="!projectLinkJoinEnabled || isRegeneratingProjectLink"
              (click)="regenerateProjectInviteLink()">Regenerate</button>
            <button class="notif-toggle" type="button" [class.notif-toggle--on]="projectLinkJoinEnabled"
              [disabled]="isUpdatingProjectLinkJoin" (click)="toggleProjectLinkJoin()"
              [attr.aria-label]="(projectLinkJoinEnabled ? 'Disable ' : 'Enable ') + 'inviting members via link'">
              <span class="notif-toggle-thumb"></span>
            </button>
          </div>
        </div>

        <div class="info-row info-row--with-action">
          <div>
            <label>Auto-expire invite links</label>
            <p class="info-hint">Invite members will be assigned this role when they join.</p>
          </div>
          <button class="notif-toggle" type="button" [class.notif-toggle--on]="autoExpireInviteLinks"
            (click)="autoExpireInviteLinks = !autoExpireInviteLinks" aria-label="Toggle auto-expire invite links">
            <span class="notif-toggle-thumb"></span>
          </button>
        </div>

        <div class="info-row info-row--with-action">
          <div>
            <label>Allow members to invite others</label>
            <p class="info-hint">Let member roles send invitations</p>
          </div>
          <button class="notif-toggle" type="button" [class.notif-toggle--on]="allowMembersToInvite"
            (click)="allowMembersToInvite = !allowMembersToInvite" aria-label="Toggle allow members to invite others">
            <span class="notif-toggle-thumb"></span>
          </button>
        </div>

        <div class="info-row info-row--with-action">
          <div>
            <label>Default role for new members</label>
            <p class="info-hint">This role will be assigned to anyone who joins {{ selectedProjectName }} via the invite
              link.</p>
          </div>
          <div class="role-select-wrap">
            <select class="role-select" [ngModel]="projectDefaultRole"
              (ngModelChange)="onProjectDefaultRoleChange($event)" [disabled]="isSavingProjectDefaultRole">
              @for (option of projectDefaultRoleOptions; track option.id) {
              <option [value]="option.id">{{ option.label }}</option>
              }
            </select>
            <lucide-icon name="chevron-down" [size]="12" class="role-select-chevron" />
          </div>
        </div>

        <div class="info-row info-row--with-action">
          <div>
            <label>Default request assignee</label>
            <p class="info-hint">This user will be automatically assigned whenever a new request is created.</p>
          </div>
          <div class="assignee-select-wrap">
            <span class="assignee-avatar">
              @if (defaultAssigneeMember?.user?.avatar) {
              <img [src]="defaultAssigneeMember?.user?.avatar" alt="" />
              } @else if (defaultAssigneeMember) {
              <span class="assignee-avatar-initials">{{ defaultAssigneeMember.user.first_name[0] +
                defaultAssigneeMember.user.last_name[0] }}</span>
              }
            </span>
            <select class="assignee-select" [ngModel]="defaultAssigneeId" (ngModelChange)="setDefaultAssignee($event)"
              [disabled]="isSavingDefaultAssignee">
              <option [value]="null">Unassigned</option>
              @for (member of activeProjectMembers; track member.id) {
              <option [value]="member.user.user_id">{{ member.user.first_name }} {{ member.user.last_name }}</option>
              }
            </select>
            <lucide-icon name="chevron-down" [size]="12" class="assignee-select-chevron" />
          </div>
        </div>

        <div class="members-title">Members</div>

        @if (projectMembersLoading) {
        <div class="notif-settings-status">Loading members…</div>
        } @else if (projectMembersError) {
        <div class="notif-settings-status">Couldn't load members. Try again.</div>
        } @else {
        <div class="members-table">
          <div class="members-table-header">
            <span>Name</span>
            <span>Role</span>
            <span>Projects involved</span>
            <span>Last Active</span>
            <span></span>
          </div>

          @for (member of pagedProjectMembers; track member.id) {
          <div class="members-table-row">
            <div class="member-cell">
              <span class="member-avatar">
                <span class="member-avatar-initials">{{ member.name.slice(0, 2).toUpperCase() }}</span>
              </span>
              <div class="member-text">
                <p class="member-name">{{ member.name }}</p>
                <p class="member-email">{{ member.email }}</p>
              </div>
            </div>
            @if (canEditMemberRoles && hasResolvedRoleId(member.id)) {
            <select class="member-role-select" [ngModel]="memberRoleOptionId(member)"
              [disabled]="isSavingMemberRole(member.id) || projectRolesLoading"
              (ngModelChange)="onMemberRoleChange(member, $event)">
              @for (option of projectRoleOptions; track option.id) {
              <option [value]="option.id">{{ option.label }}</option>
              }
            </select>
            } @else {
            <span class="member-placeholder-cell">{{ member.role ?? '—' }}</span>
            }
            <span class="member-placeholder-cell">{{ member.projects_involved }}</span>
            <span class="member-placeholder-cell">{{ member.last_active ? (member.last_active | date) : '—' }}</span>
            @if (canRemoveProjectMember(member)) {
            <div class="member-action-menu-wrap">
              <button type="button" class="member-action-btn" (click)="toggleMemberMenu(member.id)"
                aria-label="Member actions">
                <lucide-icon name="ellipsis-vertical" [size]="14" />
              </button>
              @if (openMemberMenuId === member.id) {
              <div class="member-action-menu">
                <button type="button" class="member-action-menu-item" (click)="requestRemoveMember(member)">
                  Remove member
                </button>
              </div>
              }
            </div>
            } @else {
            <span></span>
            }
          </div>
          }
        </div>

        <div class="members-pagination">
          <span class="members-pagination-label">{{ projectMemberPageRangeLabel }}</span>
          <div class="members-pagination-right">
            <select class="members-page-size" [ngModel]="projectMemberPageSize"
              (ngModelChange)="setProjectMemberPageSize($event)">
              @for (size of pageSizeOptions; track size) {
              <option [value]="size">{{ size }} per page</option>
              }
            </select>
            <div class="members-pagination-controls">
              <button type="button" class="page-nav-btn" [disabled]="projectMemberCurrentPage === 1"
                (click)="setProjectMemberPage(projectMemberCurrentPage - 1)" aria-label="Previous page">
                <lucide-icon name="chevron-left" [size]="14" />
              </button>
              @for (page of projectMemberPageNumbers; track page) {
              <button type="button" class="page-pill" [class.active]="page === projectMemberCurrentPage"
                (click)="setProjectMemberPage(page)">{{ page }}</button>
              }
              <button type="button" class="page-nav-btn"
                [disabled]="projectMemberCurrentPage === projectMemberTotalPages"
                (click)="setProjectMemberPage(projectMemberCurrentPage + 1)" aria-label="Next page">
                <lucide-icon name="chevron-right" [size]="14" />
              </button>
            </div>
          </div>
        </div>
        }
      </section>

      <section class="settings-section" id="integrationsSection">
        <h3 class="section-label">Integrations</h3>
        <hr class="section-divider" />

        <div class="integration-row">
          <div class="integration-text">
            <p class="integration-title">Webflow
              @if (webflowConnected && webflowConnectedSince) {
              <span class="integration-connected-since">Connected since {{ webflowConnectedSince }}</span>
              }
            </p>
            <p class="info-hint">Connect your Webflow site to sync and publish content via the Webflow API.</p>
          </div>
          @if (webflowConnected) {
          <button class="btn-danger-outline" [disabled]="webflowLoading"
            (click)="disconnectWebflow()">Disconnect</button>
          } @else {
          <button class="btn-integration-connect" [disabled]="webflowLoading" (click)="connectWebflow()">{{
            webflowLoading ? 'Connecting…' : 'Connect' }}</button>
          }
        </div>

        <div class="integration-row">
          <div class="integration-text">
            <p class="integration-title">Slack</p>
            <p class="info-hint">Get notified in Slack when requests are created or completed</p>
          </div>
          @if (slackConnected) {
          <button class="btn-danger-outline" [disabled]="slackLoading" (click)="disconnectSlack()">Disconnect</button>
          } @else {
          <button class="btn-integration-connect" [disabled]="slackLoading" (click)="connectSlack()">{{ slackLoading ?
            'Connecting…' : 'Connect' }}</button>
          }
        </div>

        <div class="integration-row">
          <div class="integration-text">
            <p class="integration-title">Google Chat</p>
            <p class="info-hint">Get notified in Google Chat when requests are created or completed</p>
          </div>
          @if (gchatConnected) {
          <button class="btn-danger-outline" [disabled]="gchatLoading" (click)="disconnectGchat()">Disconnect</button>
          } @else if (!gchatPickerOpen) {
          <button class="btn-integration-connect" [disabled]="gchatLoading" (click)="openGchatPicker()">Connect</button>
          }
        </div>

        @if (!gchatConnected && gchatPickerOpen) {
        <div class="gchat-picker">
          @if (gchatSpacesLoading) {
          <span class="notif-settings-status">Loading spaces…</span>
          } @else {
          <select class="members-page-size" [(ngModel)]="gchatSelectedSpaceName">
            <option value="">Select a space…</option>
            @for (space of gchatSpaces; track space.name) {
            <option [value]="space.name">{{ space.displayName }}</option>
            }
          </select>
          <button class="btn-text" [disabled]="gchatConnecting" (click)="cancelGchatPicker()">Cancel</button>
          <button class="btn-primary" [disabled]="!gchatSelectedSpaceName || gchatConnecting"
            (click)="connectGchat()">{{ gchatConnecting ? 'Connecting…' : 'Connect' }}</button>
          }
        </div>
        }
      </section>

      <section class="settings-section">
        <div class="danger-box">
          <p class="section-label">Danger zone</p>

          <div class="danger-row">
            <div>
              <p class="danger-title">Leave project</p>
              <p class="danger-desc">Remove your account from this project. You'll lose access to all of its
                content.</p>
            </div>
            <button class="btn-danger-outline" (click)="openLeaveProjectConfirm()">Leave project</button>
          </div>

          @if (canDeleteProject) {
          <div class="danger-row">
            <div>
              <p class="danger-title">Delete project</p>
              <p class="danger-desc">Permanently delete this project and all sites in it.</p>
            </div>
            <button class="btn-danger" (click)="openDeleteProjectConfirm()">Delete project</button>
          </div>
          }
        </div>
      </section>
      }
    </div>
  </div>

  @if (deleteProjectConfirmOpen) {
  <div class="nested-modal-overlay" (click)="closeDeleteProjectConfirm()">
    <div class="nested-modal-card" (click)="$event.stopPropagation()">
      <div class="danger-zone-header">
        <lucide-icon name="alert-triangle" [size]="20" class="danger-icon" />
        <h4 class="delete-confirmation-title">Delete "{{ selectedProjectName }}"?</h4>
      </div>
      <p class="delete-confirmation-message">
        This action <strong>cannot be undone</strong>. It permanently deletes the project, every member's access,
        all request tickets, sites and pages, and any connected integrations.
      </p>
      <div class="form-group">
        <label for="deleteProjectConfirm">Type <strong>{{ selectedProjectName }}</strong> to confirm.</label>
        <input type="text" id="deleteProjectConfirm" [ngModel]="deleteProjectConfirmText"
          (ngModelChange)="deleteProjectConfirmText = $event" [placeholder]="selectedProjectName" autocomplete="off"
          class="delete-confirm-input" [disabled]="isDeletingProject" />
      </div>
      @if (deleteProjectError) {
      <div class="delete-site-error-message">{{ deleteProjectError }}</div>
      }
      <div class="nested-modal-actions">
        <button type="button" class="btn-secondary" [disabled]="isDeletingProject"
          (click)="closeDeleteProjectConfirm()">Cancel</button>
        <button type="button" class="btn-confirm-delete" [disabled]="!canConfirmDeleteProject || isDeletingProject"
          (click)="confirmDeleteProject()">
          {{ isDeletingProject ? 'Deleting…' : 'Delete project' }}
        </button>
      </div>
    </div>
  </div>
  }

  <declunk-confirm-dialog [isOpen]="!!removeMemberPendingTarget"
    title="Remove {{ removeMemberPendingTarget?.name }}?"
    message="They'll lose access to this project immediately. This can't be undone." confirmLabel="Remove" [danger]="true"
    (confirmed)="confirmRemoveMember()" (cancelled)="cancelRemoveMember()" />

  <declunk-confirm-dialog [isOpen]="leaveProjectConfirmOpen" title="Leave &quot;{{ selectedProjectName }}&quot;?"
    message="You'll lose access to all of its content. You can only rejoin if you're invited again."
    [confirmLabel]="isLeavingProject ? 'Leaving…' : 'Leave project'" [danger]="true"
    (confirmed)="confirmLeaveProject()" (cancelled)="closeLeaveProjectConfirm()" />
</div>
}
